export const environment = {
  production: true,
  authIssuer: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_LRWPWmk0y',
  apiUrl: '/api',
  mediaUrl: '/media',
  signupUrl: 'https://login.grocerylistgenerator.com/signup'
};
